// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1yy2t","disabled":"FileBtn_disabled__2Y6jK","warn":"FileBtn_warn__1qe5l","fade":"FileBtn_fade__363So"};